import React from 'react';
import PropTypes from 'prop-types';

const defaultDivSetting = {
  taboola: {
    className: 'wdt-taboola',
    'data-target_type': 'mix',
    'data-mode': 'thumbnails-below',
    'data-placement': 'Below Category Thumbnails',
    'data-pagetype': 'category',
  },
};

function AdStaticDiv(props) {
  const {
    divId,
    adType,
    adDivInfo,
    mode,
    placement,
    articleIndex,
    pagetype,
  } = props;
  const defaultDivInfo = defaultDivSetting[adType] || {};
  const dynamicData = {};
  if (mode) {
    dynamicData['data-mode'] = mode;
  }

  if (pagetype) {
    dynamicData['data-pagetype'] = pagetype;
  }

  if (placement) {
    const asIndex = articleIndex > -1 ? ` ${articleIndex + 1}` : '';
    dynamicData['data-placement'] = `${placement}${asIndex}`;
  }

  return (
    <div
      key={divId}
      id={divId}
      {...defaultDivInfo}
      {...dynamicData}
      {...adDivInfo}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: '' }}
      suppressHydrationWarning
    />
  );
}
AdStaticDiv.propTypes = {
  divId: PropTypes.string,
  adType: PropTypes.string,
  adDivInfo: PropTypes.shape({}),
  mode: PropTypes.string,
  placement: PropTypes.string,
  pagetype: PropTypes.string,
  articleIndex: PropTypes.number,
};
AdStaticDiv.defaultProps = {
  divId: '',
  adType: '',
  adDivInfo: {},
  mode: '',
  placement: '',
  pagetype: '',
  articleIndex: -1,
};

export default AdStaticDiv;
